import type { ProductLogoSmallProps } from '../types';
export function ProductLogoSmallMyProfile({
  size = 20,
  color = '#646467',
  ...props
}: ProductLogoSmallProps) {
  return <svg width={size} height={size} viewBox="0 0 480 480" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M240 252C289.706 252 330 211.706 330 162C330 112.294 289.706 72 240 72C190.294 72 150 112.294 150 162C150 211.706 190.294 252 240 252Z" fill={color} />
      <path d="M180 276C126.981 276 84 318.981 84 372V384C84 397.255 94.7452 408 108 408H372C385.255 408 396 397.255 396 384V372C396 318.981 353.019 276 300 276H180Z" fill={color} />
    </svg>;
}